import React from 'react';
import stepsIcon from 'assets/images/ui/icon-steps.svg';
import textIcon from 'assets/images/ui/icon-text.svg';
import styles from './NodeCardStats.module.scss';

interface NodeCardStatsProps {
  stepsCount: number;
  wordsCount: number;
}

export function NodeCardStats({
  stepsCount,
  wordsCount,
}: NodeCardStatsProps): React.ReactElement {
  return (
    <div className={styles.statsContainer}>
      <div className={styles.statsItem} title={`Steps: ${stepsCount}`}>
        <img src={stepsIcon} alt="steps" />
        <div className="ml-1">
          {stepsCount}
        </div>
      </div>
      <div className={styles.statsItem} title={`Words: ${wordsCount}`}>
        <div className="d-flex">
          <img src={textIcon} alt="text" />
          <div className="ml-1">
            {wordsCount}
          </div>
        </div>
      </div>
    </div>
  );
}
